import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  searchInput: {
    marginRight: theme.spacing(1),
    maxWidth: 300
  },
  buttonNewTask: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  tableRowEven: {
    backgroundColor: theme.palette.background.default
  },
  tableRowOdd: {
    backgroundColor: theme.palette.background.paper
  },
  overdueRow: {
    backgroundColor: '#9e0c1bff !important',
    '&:hover': {
      backgroundColor: '#5f030cff !important'
    }
  },
  priorityHigh: {
    backgroundColor: '#f44336',
    color: 'white'
  },
  priorityMedium: {
    backgroundColor: '#ff9800',
    color: 'white'
  },
  priorityLow: {
    backgroundColor: '#4caf50',
    color: 'white'
  },
  taskTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5)
  },
  taskDescription: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontStyle: 'italic'
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  contactName: {
    fontWeight: 500
  },
  contactNumber: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  overdueText: {
    color: '#f44336',
    fontWeight: 'bold'
  },
  filterSection: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius
  },
  filterTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.blue_300.main,
    fontWeight: 'bold'
  },
  helpSection: {
    marginBottom: theme.spacing(2)
  },
  accordion: {
    marginBottom: theme.spacing(1),
    '&:before': {
      display: 'none'
    }
  },
  accordionSummary: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main
    }
  },
  accordionDetails: {
    flexDirection: 'column'
  },
  tutorialButton: {
    marginTop: theme.spacing(1)
  },
  chip: {
    fontWeight: 'bold',
    fontSize: '0.75rem'
  },
  dateCell: {
    fontSize: '0.875rem'
  },
  overdueBadge: {
    marginLeft: theme.spacing(0.5),
    fontSize: '1rem'
  },
  '@global': {
    '@keyframes pulse': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.7
      },
      '100%': {
        opacity: 1
      }
    }
  }
}));
